<template>
  <div class="mealSort">
    <div class="title-box">
      <el-form
        inline
        class="hook right themed-form search-form"
        style="line-height: 40px"
        :model="queryForm"
      >
       <el-form-item>
            <div style="color:#f00">请联系运营，让研发打开配置开关和代理商编辑不选择套餐样式才生效，自定义套餐排序优先级最低。</div>
            </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="themed-button"
            @click="addRecord"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="content-box">
      <el-table
        ref="table"
        :data="tableData"
        stripe
        border
        :max-height="maxTableHeight"
      >
        <el-table-column
          label="序号"
          prop="sort"
          width="80px"
        ></el-table-column>
         <el-table-column
          label="名称"
          prop="name"
          width="100px"
        ></el-table-column>
       
        <el-table-column
          label="卡组合"
          prop="cardType"
          width="180px"
        >
          <template slot-scope="scope">
            <span>{{cardTypeMap[scope.row.cardType]}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="流量类型"
          prop="flowType"
          width="180px"
        >
          <template slot-scope="scope">
            <span>{{flowTypeMap[scope.row.flowType]}}</span>
          </template>
        </el-table-column>
        
        <el-table-column
          label="备注"
          prop="remark"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          width="180px"
        ></el-table-column>
        <el-table-column label="操作" width="240px">
          <template slot-scope="scope">
             <el-button
              class="themed-button"
              @click="editRecord(scope.row)"
                type="primary"
              >编辑</el-button
            >
            <el-button
              class="themed-button"
              @click="deleteRecord(scope.row)"
                type="primary"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[5, 10, 15, 50, 100]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      :title="addForm.id ? '编辑套餐分类' : '新增套餐分类'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      @close="closeDialog()"
    >
      <el-form
        label-position="right"
        label-width="120px"
        :model="addForm"
        ref="addForm"
        :rules="rules"
      >
        <el-form-item label="序号:"  prop="sort">
          <el-input v-model="addForm.sort" ></el-input>
        </el-form-item>
          <el-form-item label="名称:" required prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
        <el-form-item label="卡组合:" required prop="cardType">
          <el-select v-model="addForm.cardType" placeholder="请选择" @change="handleCardTypeChange">
            <el-option
              v-for="(value, key) in cardTypeMap"
              :key="key"
              :label="value"
              :value="key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="流量类型:" required prop="flowType" v-if="showFlowType">
          <el-select v-model="addForm.flowType" placeholder="请选择">
            <el-option
              v-for="(value, key) in flowTypeMap"
              :key="key"
              :label="value"
              :value="key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input
            v-model="addForm.remark"
            type="textarea"
            placeholder="请输入内容"
            maxlength="255"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()">确 定</el-button>
        <el-button @click="cancel()">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* 需要修改的点   列表接口返回赋值修改， 编辑缺失， */
import {mealGroupClassifyList, saveMealGroupClassify, deleteMealGroupClassify} from '@/api/setMealManagment/mealRules.js'
import resize from "@/mixins/resize.js";

export default {
  name: "mealSort",
  mixins: [resize],
  data() {
    // oninput="value=value.replace(/[^\d]/g,'')" @input="(val) => { if(val <= 0) addForm.sort = ''; }"
    var validateSort = (rule, value, callback) => {
      if (!value) {
        callback(new Error("序号不能为空"));
      } else if (!/^\d+$/.test(value) || parseInt(value) <= 0) {
        callback(new Error("只能输入大于0的整数"));
      } else {
        callback();
      }
    };
    var validateName = (rule, value, callback) => {
      if (value.trim() === "") {
        console.log(321)
        callback(new Error("名称不能为空"));
      } else if (value.length > 8) {
         console.log(324)
        callback(new Error("名称不能超过8个字符,请重新输入"));
      } else {
        console.log(329)
        callback();
      }
    };
    return {
      showFlowType: true,
      queryForm: {},
      tableData: [],
      pageNo: 1,
      pageSize: 15,
      total: 0,
      dialogVisible: false,
      addForm: {
        id: "",
        sort: "",
        cardType: "",
        flowType: "",
        remark: "",
        name: "",
      },
      rules: {
        //sort: [{ required: true, message: "只能输入大于0的整数", trigger: "blur" }],
          sort: [{ validator: validateSort, trigger: "blur" }],
        name: [{ validator: validateName, trigger: "blur" }],
        cardType: [{ required: true, message: "请选择卡类型", trigger: "change" }],
        flowType: [{ required: true, message: "请选择流量类型", trigger: "change" }]
      },
      cardTypeMap: {
        0: "默认",
        1: "单网套餐（电信）",
        2: "单网套餐（联通）", 
        3: "单网套餐（移动）",
        4: "双网套餐（电信+联通）",
        5: "双网套餐（电信+移动）",
        6: "双网套餐（移动+联通）",
        7: "三网套餐（三网通）"
      },
      flowTypeMap: {
        0: "默认",
        1: "省内流量",
        2: "全国流量"
      },
      originArr: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      mealGroupClassifyList(params).then(res => {
        if(res.page) {
          this.tableData = res.page.rows;
          this.total = res.page.total;
          this.pageNo = res.page.pageNo;
          this.pageSize = res.page.pageSize;
          this.originArr = res.page.rows;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    addRecord() {
      this.dialogVisible = true;
    },
    deleteRecord(row) {
      this.$confirm("删除该分类会导致正在使用该分类的套餐异常，确认要删除该数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteMealGroupClassify({
            id: row.id
          }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getList();
          });
        })
        .catch(() => {});
    },
    submitForm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          console.log(valid)
          let params = {...this.addForm};
          if(!this.addForm.id) {
            delete params.id;
          }
          saveMealGroupClassify(params).then(() => {
            this.$message({
              type: "success",
              message: "保存成功!"
            });
            this.dialogVisible = false;
            this.getList();
            this.resetForm();
          });
        }
      });
    },
    cancel() {
      this.dialogVisible = false;
      this.resetForm();
    },
    closeDialog() {
      this.resetForm();
    },
    resetForm() {
      this.addForm = {
        id: "",
        sort: "",
        cardType: "",
        flowType: "",
        remark: "",
        name: "",
      };
      if (this.$refs["addForm"]) {
        this.$refs["addForm"].resetFields();
      }
    },
    editRecord(row) {
      this.addForm = {
        id: row.id,
        sort: row.sort,
        cardType: row.cardType+"",
        flowType: row.flowType+"",
        remark: row.remark,
        name: row.name,
      };
      this.showFlowType = this.addForm.cardType === '0';
      this.dialogVisible = true;
    },
    handleCardTypeChange(val) {
      this.showFlowType = val === '0';
      if (!this.showFlowType) {
        this.addForm.flowType = '0';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mealSort {
  padding: 20px;
  .title-box {
    margin-bottom: 20px;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
